import JobsGrid from '../../components/grids/JobsGrid'
import AddJobForm from '../../components/FormComps/Jobs/AddJobForm'
import EditJobForm from '../../components/FormComps/Jobs/EditJobForm'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { useState, useEffect } from 'react'
import { useToast } from '../../contexts/ToastContext'
import { useSessionState } from '../../helpers/useSessionState'

import { Drawer, DrawerContent, DrawerNavigation } from '@progress/kendo-react-layout'
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs'
import { FaTimes } from 'react-icons/fa'

import {
  submitJob,
  updateJob,
  exportJobs,
  exportJobsheet,
  getJobs, 
  completeJob, 
  deleteJob,
  submitJobSageTest,
  updateJobSageTest,
  //updateJobToSage,
  //addJobToSage,
  getJobCostingData,
  JobCostingItem
} from '../../data/jobData'

import { DateFormatterReverse } from '../../data/helper'

import {
  jobsGrid,
  getSiteTypes,
  dropDown,
  clientsGrid,
} from '../../data/interfaces'

import { submitSite, getSites } from '../../data/siteData'
import { submitClient, getClients } from '../../data/clientData'
import {
  getWorktypeDropdown,
  postWorkType,
  submitWorktype,
} from '../../data/worktypeData'

import AddClientForm from '../../components/FormComps/Clients/AddClientForm'
import AddSiteForm from '../../components/FormComps/Sites/AddSiteForm'
import AddWorkTypeForm from '../../components/FormComps/Worktypes/AddWorkTypeForm'

import '../Styles.css'
import { submitInvoice } from '../../data/invoiceData'
import { submitInvoiceItem } from '../../data/invoiceItemData'
import { deleteDocument } from '../../data/fileData'
import JobCostingsGrid from '../../components/grids/JobCostingsGrid'
import AccountForm from '../../components/FormComps/Accounts/AccountForm'

interface JobsProps {
  lockEdit: boolean
}

const Jobs = (props: JobsProps) => {
  const navigate = useNavigate()

  // Modal visibility states
  const [visibleClientModal, setVisibleClientModal] = useState<boolean>(false)
  const [visibleSiteModal, setVisibleSiteModal] = useState<boolean>(false)
  const [visibleWorktypeModal, setVisibleWorktypeModal] =
    useState<boolean>(false)
  const [visibleDeleteConfirm, setVisibleDeleteConfirm] = useState(false)

  // Data sets
  const [clientData, setClientData] = useState<clientsGrid[]>([])
  const [siteData, setSiteData] = useState<getSiteTypes[]>([])
  const [workTypeData, setWorktypeData] = useState<dropDown[]>([])
  const [jobData, setJobData] = useState<jobsGrid[]>([])

  const dateFormatterReverse = new DateFormatterReverse()
  const [expanded, setExpanded] = useState(false)
  const [editFormVisible, setEditFormVisible] = useState(false)
  const [addFormVisible, setAddFormVisible] = useState(false)
  const [jobId, setJobId] = useState(0)

  // Same session keys as JobsGrid so the page and the grid restore in step
  const [showCompleted, setShowCompleted] = useSessionState('jobs.showCompleted', false)
  const [showDeleted, setShowDeleted] = useSessionState('jobs.showDeleted', false)
  const [showEngineerComments, setShowEngineerComments] = useSessionState('jobs.showEngineerComments', false)
  const [showRemedialWorks, setShowRemedialWorks] = useSessionState('jobs.showRemedialWorks', false)
  const [refreshKey, setRefreshKey] = useState(0)

  const [jobCostingVisible, setJobCostingVisible] = useState(false);
  const [clientFromIncoming, setClientFromIncoming] = useState<string>("")

  // Friendly job reference for the edit drawer header (reported by EditJobForm
  // once it loads the job).
  const [editJobRef, setEditJobRef] = useState<string>("")

  // Responsive job-drawer width: roomier on large screens (room for the new
  // vertical nav rail), and caps at the viewport on smaller displays.
  const [jobDrawerWidth, setJobDrawerWidth] = useState(() =>
    Math.min(1200, Math.round(window.innerWidth * 0.94))
  )
  useEffect(() => {
    const onResize = () =>
      setJobDrawerWidth(Math.min(1200, Math.round(window.innerWidth * 0.94)))
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  const [searchParams] = useSearchParams();
  useEffect(() => {
    const client = searchParams.getAll("client")[0];
    const id = searchParams.getAll("id")[0];
    if(id) {
      setExpanded(true);
      setEditFormVisible(true);
      setJobId(Number(id))
    }
    if(client){
      setClientFromIncoming(client);
    }
  }, [])  

  const { showToast } = useToast()

  const handleShowCompleted = (value: boolean) => {
    setShowCompleted(value)
  }

  const handleShowDeleted = (value: boolean) => {
    setShowDeleted(value)
  }

  const handleShowEngineerComments = (value: boolean) => {
    setShowEngineerComments(value)
  }

  const handleShowRemedialWorks = (value: boolean) => {
    setShowRemedialWorks(value)
  }

  const handleAddForm = () => {
    setAddFormVisible((prevState) => (!prevState ? true : true))
    setEditFormVisible(false)
    handleExpanded()
  }

  const handleEditForm = (id: number) => {
    setJobId(id)
    setEditJobRef("")
    setEditFormVisible((prevState) => (!prevState ? true : true))
    setAddFormVisible(false)
    handleExpanded()
  }

  const removeDocuemntHandler = (id: number) => {
    deleteDocument(id).then(() => {
      const fetchData = async () => {
        const jobData = await getJobs(showCompleted, showDeleted, showEngineerComments, showRemedialWorks)
        setJobData(jobData)
      }
      fetchData()
    })
    showToast('Successfully removed document', 'success')
  }

  const toggleModal = (type: string) => {
    switch (type.toLowerCase()) {
      case 'client':
        setVisibleClientModal(!visibleClientModal)
        break
      case 'site':
        setVisibleSiteModal(!visibleSiteModal)
        break
      case 'worktype':
        setVisibleWorktypeModal(!visibleWorktypeModal)
        break
      case 'deleteconfirm':
        setVisibleDeleteConfirm(!visibleWorktypeModal)
        break
      default:
        console.log('Invalid modal type.')
        break
    }
  }

  const updateJobHandler = (dataItem: any, id: number) => {
    const jobObj = {
      contact: {
        contactId: dataItem.contact.contactId,
      },
      jobId: id,
      clientId: dataItem.clientName.value,
      siteId: dataItem.siteAddr.value,
      contactId: dataItem.contact.contactId,
      //TODO: 11th Feb remove hardcoded priorityId
      priorityId: 1,
      enquirysourceId: dataItem.enquirysourceId.value,
      departmentId: 1,
      description: dataItem.description,
      purchaseOrder: dataItem.purchaseOrder,
      externallyBooked: dataItem.externallyBooked,
      externallyBookedName: dataItem.externallyBookedName,
      worktypeId: dataItem.worktypeId.value,
      cost: dataItem.cost,
      proformaCost: dataItem.proformaCost,
      firstHourInvoiced: dataItem.firstHourInvoiced,
      completedDate: dataItem.completedDate === '' ? null : dataItem.completedDate,
      deletedDate: dataItem.deletedDate === '' ? null : dataItem.deletedDate,
      startDate: dateFormatterReverse.format(dataItem.startDate),
      endDate: dateFormatterReverse.format(dataItem.endDate),
      employeeProjectmanager: dataItem.employeeProjectmanager.value,
      quoteId:
        dataItem.quoteId && dataItem.quoteId.value
          ? dataItem.quoteId.value
          : null,
      jobEmployeeIds: dataItem.jobEmployees.map((item: any) => {
        // Handle both object format {text, value} and direct numeric values
        return typeof item === 'object' ? item.value : item;
      }).filter((id: any) => id && id !== 0), // Filter out empty values
      scheduledStartDate: dateFormatterReverse.format(dataItem.scheduledStartDate),
      scheduledEndDate: dateFormatterReverse.format(dataItem.scheduledEndDate),
      projectFolderUrl: dataItem.projectFolderUrl,
      notifiableWorks: Array.isArray(dataItem.notifiableWorks) ? dataItem.notifiableWorks.join(',') : (dataItem.notifiableWorks || ''),
      inDefect: dataItem.inDefect || false,
      enableSubcontractAgreements: dataItem.enableSubcontractAgreements || false,
      workingsAdjustmentPercent: dataItem.workingsAdjustmentPercent ?? null,
    }

    updateJobSageTest(jobObj, id)
      .then(() => {
        const fetchData = async () => {
          const jobData = await getJobs(showCompleted, showDeleted, showEngineerComments, showRemedialWorks)
          setJobData(jobData)
        }
        fetchData();
        // Increment refresh key to trigger grid reload
        setRefreshKey(prev => prev + 1);
      }).catch((res) => {
          console.log(`Error adding job to portal. Error: ${res}`)
          showToast('Error adding job', 'error')
        })
        .then(() => {
          handleExpanded()
          showToast('Job succesfully updated', 'success')
        }).catch((res) => {
            console.log(`Error adding job to sage. Error: ${res}`)
            showToast('Error adding job', 'error')
          })

/*

          updateJobSageTest(jobObj, id)
      .then(() => {
        const fetchData = async () => {
          const jobData = await getJobs(showCompleted, showDeleted, showEngineerComments, showRemedialWorks)
          setJobData(jobData)
        }
        fetchData();
      }).catch((res) => {
          console.log(`Error adding job to portal. Error: ${res}`)
          showToast('Error adding job', 'error')
        })
        .then(() => {
          updateJobToSage(id)
            .then(() => {
              handleExpanded()
            })
          showToast('Job succesfully updated', 'success')
        }).catch((res) => {
            console.log(`Error adding job to sage. Error: ${res}`)
            showToast('Error adding job', 'error')
          })
            */
  }

  const newJobHandler = (dataItem: any) => {
    let newJobId: number | null;
    const jobObj = {
      jobId: null,
      clientId: dataItem.clientName.value,
      siteId: dataItem.siteAddr.value,
      contactId: dataItem.contact.value,
      //TODO: 11th Feb remove hardcoded priorityId
      priorityId: 1,
      enquirysourceId: dataItem.enquirysourceId.value ? dataItem.enquirysourceId.value : 0,
      description: dataItem.description,
      purchaseOrder: dataItem.purchaseOrder,
      departmentId: 1,
      worktypeId: dataItem.worktypeId.value,
      cost: dataItem.cost ? dataItem.cost : 0,
      proformaCost: dataItem.proformaCost ? dataItem.proformaCost : 0,
      firstHourInvoiced: dataItem.firstHourInvoiced,
      startDate: dataItem.startDate.toISOString(),
      endDate: dataItem.endDate.toISOString(),
      employeeProjectManagerId: dataItem.employeeProjectManagerId.value,
      enquiryId: dataItem.enquiryId ? dataItem.enquiryId.value : null,
      quoteId:
        dataItem.quoteId && dataItem.quoteId.value
          ? dataItem.quoteId.value
          : null,
      jobEmployeeIds: [],
      scheduledStartDate: null,
      scheduledEndDate: null,
      notifiableWorks: Array.isArray(dataItem.notifiableWorks) ? dataItem.notifiableWorks.join(',') : (dataItem.notifiableWorks || ''),
    }
    submitJobSageTest(jobObj)
      .then((res) => {
        newJobId = res.jobId;
        handleRefreshData();
      }).catch((res) => {
          console.log(`Error adding job to portal. Error: ${res}`)
          showToast('Error adding job', 'error')
        })
        .then(() => {
          newJobId = newJobId ? newJobId : 0;
          handleExpanded()
          showToast('Job succesfully added', 'success')
        }).catch((res) => {
            console.log(`Error adding job to sage. Error: ${res}`)
            showToast('Error adding job', 'error')
          })
  }

  const handleRefreshData = async () => {
    const jobData = await getJobs(showCompleted, showDeleted, showEngineerComments, showRemedialWorks);
    setJobData(jobData);
    setRefreshKey(prev => prev + 1);
  };

  const newClientHandler = (dataItem: any) => {
    const clientObj = {
      clientName: dataItem.clientName,
      accountRef: dataItem.accountRef ? dataItem.accountRef : null,
      contactName: dataItem.contactFirstName + ' ' + dataItem.contactLastName,
      phone: dataItem.phone,
      email: dataItem.email ? dataItem.email : null,
      clientAddr: dataItem.clientAddr,
      postcode: dataItem.postcode,
      phone2: dataItem.phone2 ? dataItem.phone2 : null,
      fax: dataItem.fax ? dataItem.fax : null,
      tradeContact: dataItem.tradeContact ? dataItem.tradeContact : null,
      email2: dataItem.email2 ? dataItem.email2 : null,
      email3: dataItem.email3 ? dataItem.email3 : null,
      websiteUrl: dataItem.websiteUrl ? dataItem.websiteUrl : null,
      vatNum: dataItem.vatNum ? dataItem.vatNum : null,
      directdebitEmail: dataItem.directdebitEmail
        ? dataItem.directdebitEmail
        : null,
    }
    submitClient(clientObj).then(() => {
      const fetchData = async () => {
        const clientData = await getClients(showDeleted)
        setClientData(clientData)
      }
      fetchData()
    })
    toggleModal('client')
    showToast('Client succesfully added', 'success')
  }

  const newSiteHandler = (dataItem: any) => {
    const siteObj = {
      siteAddr: dataItem.siteAddr,
      postcode: dataItem.postcode,
    }
    submitSite(siteObj).then(() => {
      const fetchData = async () => {
        const siteData = await getSites(false)
        setSiteData(siteData)
      }
      fetchData()
    })
    toggleModal('site')
    showToast('Site succesfully added', 'success')
  }

  const newWorkTypeHandler = (dataItem: postWorkType) => {
    submitWorktype(dataItem).then(() => {
      const fetchData = async () => {
        const workTypes = await getWorktypeDropdown()
        setWorktypeData(workTypes)
      }
      fetchData()
    })
    toggleModal('worktype')
    showToast('Worktype succesfully added', 'success')
  }

  const completedJobHandler = (id: number) => {
    completeJob(id).then(() => {
      const fetchData = async () => {
        const jobData = await getJobs(showCompleted, showDeleted, showEngineerComments, showRemedialWorks)
        setJobData(jobData)
      }
      fetchData()
      // Increment refresh key to trigger grid reload
      setRefreshKey(prev => prev + 1)
    })
    handleExpanded()
    showToast('Job succesfully completed', 'success')
  }

  const [jobIdForDelete, setjobIdForDelete] = useState(0)
  const deleteJobHandler = () => {
    deleteJob(jobIdForDelete).then(() => {
      const fetchData = async () => {
        const jobData = await getJobs(showCompleted, showDeleted, showEngineerComments, showRemedialWorks)
        setJobData(jobData)
      }
      fetchData()
      // Increment refresh key to trigger grid reload
      setRefreshKey(prev => prev + 1)
    })
    handleExpanded()
    setVisibleDeleteConfirm(false)
    setjobIdForDelete(0)
    showToast('Job succesfully deleted', 'success')
  }

  const toggleDeleteConfirm = (id: number) => {
    setVisibleDeleteConfirm(true)
    setjobIdForDelete(id)
  }

  // Data fetching is now handled by JobsGrid component with server-side pagination
  // The filter states are still maintained here and passed to the grid
  // useEffect(() => {
  //   const fetchData = async () => {
  //     const jobsData = await getJobs(showCompleted, showDeleted, showEngineerComments, showRemedialWorks)
  //     setJobData(jobsData)
  //   }

  //   fetchData()
  // }, [showCompleted, showDeleted, showEngineerComments, showRemedialWorks])

  const exportJobsHandler = () => {
    exportJobs()
  }

  const exportJobsheetHandler = (id: number) => {
    exportJobsheet(id)
  }

  const handleExpanded = () => {
    setJobCostingVisible(false)
    setExpanded((prevState) => !prevState)

    if (editFormVisible) {
      setEditFormVisible(false)
      setJobId(0) // Reset jobId to force form remount when reopened
    }
    if (addFormVisible) {
      setAddFormVisible(false)
    }
  }

  const handleSelect = () => {
    setExpanded(false)
    setJobCostingVisible(false)
  }

    /**
   * Account 
   */
    const [addAccountVisible, setAddAccountVisible] = useState(false);
    const [selectedAccountId, setSelectedAccountId] = useState<number | null>(null);
    const [accountMode, setAccountMode] = useState<"add"|"edit">("add");
    const [accountInitialTab, setAccountInitialTab] = useState<number>(0);
  
    /**
     * END account 
     */
  


  return (
    <div>
      {/* Add Job Drawer */}
      <Drawer
        expanded={addFormVisible}
        mode='overlay'
        position='end'
        width={jobDrawerWidth}
        onOverlayClick={handleExpanded}
      >
        <DrawerContent>
          <DrawerNavigation>
            <div className='jobdrawer__header'>
              <h1 className='jobdrawer__title'>Add Job</h1>
              <button
                type='button'
                className='jobdrawer__close'
                onClick={handleExpanded}
                aria-label='Close'
              >
                <FaTimes />
              </button>
            </div>
            <div className='form__wrapper'>
              <AddJobForm
                key={addFormVisible ? 'add-job-open' : 'add-job-closed'}
                onJobSubmit={newJobHandler}
                onAddClientToggle={() => toggleModal('client')}
                onAddSiteToggle={() => toggleModal('site')}
                onAddWorktypeToggle={() => toggleModal('worktype')}
                updatedWorkTypes={workTypeData}
                setAddAccountVisible={setAddAccountVisible}
                setAccountMode={setAccountMode}
                setSelectedAccountId={setSelectedAccountId}
                setAccountInitialTab={setAccountInitialTab}                      
              />
            </div>
          </DrawerNavigation>
        </DrawerContent>
      </Drawer>

      {/* Edit Job Drawer */}
      <Drawer
        expanded={editFormVisible}
        mode='overlay'
        position='end'
        width={jobDrawerWidth}
        onOverlayClick={handleExpanded}
      >
        <DrawerContent>
          <DrawerNavigation>
            <div className='jobdrawer__header'>
              <h1 className='jobdrawer__title'>
                Edit Job
                {editJobRef && <span className='jobdrawer__ref'>{editJobRef}</span>}
              </h1>
              <button
                type='button'
                className='jobdrawer__close'
                onClick={handleExpanded}
                aria-label='Close'
              >
                <FaTimes />
              </button>
            </div>
            <div className='form__wrapper'>
              {jobId > 0 && (
                <EditJobForm
                  key={jobId}
                  lockEdit={props.lockEdit}
                  onEditSubmit={updateJobHandler}
                  onJobRefLoaded={setEditJobRef}
                  onJobId={jobId}
                  onCompleteJobSubmit={completedJobHandler}
                  onJobDeleteSubmit={toggleDeleteConfirm}
                  onAddClientToggle={() => toggleModal('client')}
                  onAddSiteToggle={() => toggleModal('site')}
                  onAddWorktypeToggle={() => toggleModal('worktype')}
                  onDocumentDelete={removeDocuemntHandler}
                  updatedWorkTypes={workTypeData}
                  setAddAccountVisible={setAddAccountVisible}
                  setAccountMode={setAccountMode}
                  setSelectedAccountId={setSelectedAccountId}
                  setAccountInitialTab={setAccountInitialTab}                     
                />
              )}
            </div>
          </DrawerNavigation>
        </DrawerContent>
      </Drawer>

      <JobsGrid
        clientFromIncoming={clientFromIncoming}
        lockEdit={props.lockEdit}
        onAddToggle={handleAddForm}
        onEditToggle={handleEditForm}
        onExport={exportJobsHandler}
        onJobsheet={exportJobsheetHandler}
        onExportData={jobData}
        onShowCompleted={handleShowCompleted}
        onShowDeleted={handleShowDeleted}
        onShowEngineerComments={handleShowEngineerComments}
        onShowRemedialWorks={handleShowRemedialWorks}
        refreshKey={refreshKey}
      />

      {visibleClientModal && (
            <Dialog
              width={500}
              height={700}
              title={'Please confirm'}
              onClose={() => toggleModal('client')}
            >
              <AddClientForm onClientSubmit={newClientHandler} />
            </Dialog>
          )}
          {visibleSiteModal && (
            <Dialog
              width={500}
              height={700}
              title={'Please confirm'}
              onClose={() => toggleModal('site')}
            >
              <AddSiteForm onSiteSubmit={newSiteHandler} />
            </Dialog>
          )}
          {visibleWorktypeModal && (
            <Dialog
              width={500}
              height={700}
              title={'Please confirm'}
              onClose={() => toggleModal('worktype')}
            >
              <AddWorkTypeForm onWorkTypeSubmit={newWorkTypeHandler} />
            </Dialog>
          )}
          {visibleDeleteConfirm && (
            <Dialog
              width={350}
              height={200}
              title={'Please confirm'}
              onClose={() => setVisibleDeleteConfirm(false)}
            >
              Are you sure you wish to delete this job?
              <DialogActionsBar>
                <button className='form__edit__button reject' onClick={deleteJobHandler}>
                  Confirm
                </button>
              </DialogActionsBar>
            </Dialog>
          )}
          {addAccountVisible && (
            <Dialog
              width={"70vw"}
              height={"90vh"}
              title={"Add new account"}
              onClose={() => setAddAccountVisible(false)}
            >
              <AccountForm
                onClose={() => setAddAccountVisible(false)}
                mode={accountMode} 
                id={selectedAccountId || null} 
                setAccountId={(id) => setSelectedAccountId(id)}
                initialTab={accountInitialTab}/>

            </Dialog>
          )}          
    </div>
  )
}

export default Jobs
